import AppBar from 'components/AppBar';
import { default as React } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './interfaces';
import MiddlewareError from './middlewares/MiddlewareError';
import Routes from './routes';

import AIChat from 'components/AIChat';
import EmbeddedRouteReporter from 'components/EmbeddedRouteReporter';
import PushNotification from 'components/PushNotification';
import RatingNotificationDialog from 'components/RatingNotificationDialog';
import Support from 'components/Support';
import TenantNotificationDialog from 'components/TenantNotificationDialog';
import { isEmbedded } from 'embedded';
import { USER_OPERATIONS } from 'helper';
import './assets/scss/index.scss';
import './styles.scss';

const Main: React.FC = () => {
  const user = useSelector((state: RootState) => state.user);
  const operations = useSelector((state: RootState) => state.operations);

  // Во фрейме нового интерфейса только страница: оболочку и виджеты показывает новый интерфейс
  if (isEmbedded) {
    return (
      <div className="App">
        <EmbeddedRouteReporter />
        <MiddlewareError>
          <Routes />
        </MiddlewareError>
      </div>
    );
  }

  return (
    <>
      <div className="App">
        {Boolean(Object.keys(user).length) && <AppBar />}

        <MiddlewareError>
          <Routes />
        </MiddlewareError>
      </div>

      {operations.includes(USER_OPERATIONS.AI_VIEW) && <AIChat />}
      {Boolean(Object.keys(user).length) && <Support />}
      <PushNotification />
      <RatingNotificationDialog />
      <TenantNotificationDialog />
    </>
  );
};

export default Main;
